import { render, staticRenderFns } from "./managementStandardOfFranchisee.vue?vue&type=template&id=714084c0&scoped=true"
import script from "./managementStandardOfFranchisee.vue?vue&type=script&lang=js"
export * from "./managementStandardOfFranchisee.vue?vue&type=script&lang=js"
import style0 from "./managementStandardOfFranchisee.vue?vue&type=style&index=0&id=714084c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714084c0",
  null
  
)

export default component.exports